import React from 'react';
import EditorDelete from '@wix/da-ds/pkg/Icons/24x24/EditorDelete';
import { useTranslation } from 'react-i18next';
import EditorIconButton from '../../../../components/menus/_partials/EditorIconButton';
const Delete = ({ editor })=>{
    const { t } = useTranslation('editor');
    return /*#__PURE__*/ React.createElement(EditorIconButton, {
        featureId: "node:deviation:delete",
        icon: EditorDelete,
        onClick: ()=>editor.chain().focus().daDeviationDelete().run(),
        tooltipText: t('ext.deviation.toolbar.delete'),
        "aria-label": t('ext.deviation.toolbar.delete')
    });
};
Delete.displayName = 'Delete';
export default Delete;

//# sourceMappingURL=Delete.js.map